module.exports = __webpack_public_path__ + "img/arrow.d361d17e.svg";